export const decodeAudioFile = async (
  audioFile: File
): Promise<AudioBuffer> => {
  const audioContext = new AudioContext();
  try {
    const arrayBuffer = await audioFile.arrayBuffer();
    return await audioContext.decodeAudioData(arrayBuffer);
  } finally {
    await audioContext.close();
  }
};
